export const DEFAULT_PROPS = {
    disabled: false,
    required: false,
    checked: false,
    defaultChecked: false,
    value: '',
    hasMultipleChecked: false,
};
export const CUSTOM_LABEL_INDENT = '35px';
